import ProductCard from '../components/ProductCard';
import logo from '../assets/logo.jpeg';

// Static product data (replaced by API call in production)
const products = [
  { _id: '1', name: 'Premium Makhana', nameHindi: 'मखाना', price: 349, compareAtPrice: 449, category: 'dry-fruits', weight: { value: 250, unit: 'g' }, description: 'Hand-harvested lotus seeds from Bihar, roasted to perfection.', shortDescription: 'Hand-harvested roasted lotus seeds — a protein-rich superfood snack.', ratingsAverage: 4.8, ratingsQuantity: 234, isFeatured: true },
  { _id: '2', name: 'Premium Cashews W240', nameHindi: 'काजू', price: 599, compareAtPrice: 799, category: 'dry-fruits', weight: { value: 500, unit: 'g' }, description: 'Whole W240 grade cashews sourced directly from Goan village farms.', shortDescription: 'Whole W240 grade farm-fresh Goan cashews.', ratingsAverage: 4.7, ratingsQuantity: 187, isFeatured: true },
  { _id: '3', name: 'Golden Almonds', nameHindi: 'बादाम', price: 499, compareAtPrice: 649, category: 'dry-fruits', weight: { value: 500, unit: 'g' }, description: 'Sun-dried almonds with skin intact from Kashmiri orchards.', shortDescription: 'Sun-dried Kashmiri almonds — rich in Vitamin E.', ratingsAverage: 4.6, ratingsQuantity: 156, isFeatured: true },
  { _id: '4', name: 'Walnut Kernels', nameHindi: 'अखरोट', price: 649, compareAtPrice: 850, category: 'dry-fruits', weight: { value: 250, unit: 'g' }, description: 'Premium walnut kernels from Kashmir valley.', shortDescription: 'Handpicked Kashmiri walnut kernels — omega-3 rich.', ratingsAverage: 4.7, ratingsQuantity: 98, isFeatured: false },
  { _id: '5', name: 'Pure Jaggery Block', nameHindi: 'गुड़', price: 199, compareAtPrice: 279, category: 'jaggery', weight: { value: 1, unit: 'kg' }, description: 'Traditional sugarcane jaggery made in open iron pans.', shortDescription: 'Chemical-free sugarcane jaggery — iron-rich natural sweetener.', ratingsAverage: 4.9, ratingsQuantity: 312, isFeatured: true },
  { _id: '6', name: 'Jaggery Powder', nameHindi: 'गुड़ शक्कर', price: 249, compareAtPrice: 329, category: 'jaggery', weight: { value: 1, unit: 'kg' }, description: 'Finely ground organic jaggery powder.', shortDescription: 'Finely ground organic jaggery — perfect sugar substitute.', ratingsAverage: 4.7, ratingsQuantity: 198, isFeatured: true },
  { _id: '7', name: 'Cold-Pressed Mustard Oil', nameHindi: 'सरसों का तेल', price: 399, compareAtPrice: 499, category: 'oils', weight: { value: 1, unit: 'L' }, description: 'Wood-pressed (kachi ghani) mustard oil.', shortDescription: 'Kachi ghani wood-pressed mustard oil — authentic pungent flavor.', ratingsAverage: 4.8, ratingsQuantity: 267, isFeatured: true },
  { _id: '8', name: 'Virgin Coconut Oil', nameHindi: 'नारियल तेल', price: 449, compareAtPrice: 599, category: 'oils', weight: { value: 500, unit: 'ml' }, description: 'Cold-extracted from fresh coconut flesh.', shortDescription: 'Cold-extracted virgin coconut oil — for cooking & care.', ratingsAverage: 4.6, ratingsQuantity: 145, isFeatured: false },
  { _id: '9', name: 'Groundnut Oil', nameHindi: 'मूंगफली तेल', price: 349, compareAtPrice: 449, category: 'oils', weight: { value: 1, unit: 'L' }, description: 'Traditional bull-driven ghani pressed peanut oil.', shortDescription: 'Ghani-pressed groundnut oil — light & nutty flavor.', ratingsAverage: 4.5, ratingsQuantity: 89, isFeatured: false },
  { _id: '10', name: 'Lakadong Turmeric', nameHindi: 'हल्दी', price: 179, compareAtPrice: 249, category: 'spices', weight: { value: 200, unit: 'g' }, description: 'High-curcumin Lakadong turmeric from Meghalaya.', shortDescription: 'High-curcumin Lakadong turmeric — stone-ground, deep golden.', ratingsAverage: 4.9, ratingsQuantity: 345, isFeatured: true },
  { _id: '11', name: 'Kashmiri Red Chilli', nameHindi: 'लाल मिर्च', price: 199, compareAtPrice: 269, category: 'spices', weight: { value: 200, unit: 'g' }, description: 'Sun-dried Kashmiri chillies stone-ground.', shortDescription: 'Stone-ground Kashmiri chillies — rich color, medium heat.', ratingsAverage: 4.6, ratingsQuantity: 167, isFeatured: false },
  { _id: '12', name: 'Whole Cumin Seeds', nameHindi: 'जीरा', price: 199, compareAtPrice: 259, category: 'spices', weight: { value: 200, unit: 'g' }, description: 'Aromatic whole cumin seeds from Rajasthan.', shortDescription: 'Handpicked Rajasthani cumin — essential for authentic tadka.', ratingsAverage: 4.5, ratingsQuantity: 134, isFeatured: false },
  { _id: '13', name: 'Coriander Powder', nameHindi: 'धनिया', price: 129, compareAtPrice: 179, category: 'spices', weight: { value: 200, unit: 'g' }, description: 'Freshly stone-ground from sun-dried coriander seeds.', shortDescription: 'Freshly stone-ground coriander — earthy, citrusy aroma.', ratingsAverage: 4.4, ratingsQuantity: 112, isFeatured: false },
  { _id: '14', name: 'Malabar Black Pepper', nameHindi: 'काली मिर्च', price: 299, compareAtPrice: 399, category: 'spices', weight: { value: 100, unit: 'g' }, description: 'Bold Malabar black pepper from Kerala.', shortDescription: 'Hand-harvested Malabar peppercorns — bold and intense.', ratingsAverage: 4.8, ratingsQuantity: 201, isFeatured: true },
  { _id: '15', name: 'Garam Masala', nameHindi: 'गरम मसाला', price: 219, compareAtPrice: 299, category: 'spices', weight: { value: 100, unit: 'g' }, description: 'Hand-blended aromatic spice mix.', shortDescription: 'Hand-blended aromatic spice mix — freshly roasted & ground.', ratingsAverage: 4.7, ratingsQuantity: 178, isFeatured: false },
  { _id: '16', name: 'Wild Forest Honey', nameHindi: 'जंगली शहद', price: 549, compareAtPrice: 699, category: 'honey', weight: { value: 500, unit: 'g' }, description: 'Raw, unprocessed honey collected by tribal communities.', shortDescription: 'Raw tribal-harvested wild honey — unprocessed, enzyme-rich.', ratingsAverage: 4.9, ratingsQuantity: 89, isFeatured: true },
];

const categories = [
  { id: 'all', label: 'All Products', icon: '🌾' },
  { id: 'dry-fruits', label: 'Dry Fruits', icon: '🥜' },
  { id: 'jaggery', label: 'Jaggery', icon: '🟫' },
  { id: 'oils', label: 'Oils', icon: '🫒' },
  { id: 'spices', label: 'Spices', icon: '🌶️' },
  { id: 'honey', label: 'Honey', icon: '🍯' },
];

export default function HomePage({ activeCategory, setActiveCategory }) {
  const featured = products.filter((p) => p.isFeatured);
  const filtered = activeCategory === 'all' ? products : products.filter((p) => p.category === activeCategory);

  return (
    <>
      {/* ═══════ HERO ═══════ */}
      <section id="home" style={{
        position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center',
        overflow: 'hidden',
        background: 'linear-gradient(160deg, #FAF8F2 0%, #EDE8D8 25%, #D4DCCA 55%, #B5C4A8 100%)',
      }}>
        {/* Floating botanicals */}
        {['🌿', '🍃', '🌾', '🪷', '🌱', '🍂'].map((e, i) => (
          <span key={i} style={{
            position: 'absolute', fontSize: 24 + i * 6, opacity: 0.12,
            animation: `float ${4 + i}s ease-in-out infinite`,
            animationDelay: `${i * 0.8}s`,
            left: `${8 + i * 16}%`, top: `${12 + (i % 3) * 28}%`, pointerEvents: 'none',
          }}>{e}</span>
        ))}

        <div className="container" style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48,
          alignItems: 'center', paddingTop: 100, paddingBottom: 60,
        }}>
          {/* Copy */}
          <div style={{ animation: 'fadeUp 0.8s ease-out' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              background: 'rgba(74,124,89,0.1)', padding: '6px 16px',
              borderRadius: 24, marginBottom: 20,
            }}>
              <span style={{ fontSize: 14 }}>🌱</span>
              <span style={{
                fontSize: 11, fontWeight: 600, color: '#4A7C59',
                letterSpacing: 2, textTransform: 'uppercase',
              }}>100% Organic • Village Fresh</span>
            </div>

            <h1 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(34px, 5vw, 62px)', fontWeight: 900,
              lineHeight: 1.08, color: '#2D3B2D', marginBottom: 20,
            }}>
              Pure Goodness,<br />
              <span style={{ color: '#4A7C59' }}>Straight from</span><br />
              <em style={{
                background: 'linear-gradient(135deg, #4A7C59, #8BAF6A)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>the Village</em>
            </h1>

            <p style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(16px, 2vw, 21px)', color: '#5A6B5A',
              lineHeight: 1.7, maxWidth: 460, marginBottom: 32,
            }}>
              Gramaayam brings you handpicked, chemical-free dry fruits, jaggery,
              cold-pressed oils & artisan spices — harvested with love from
              Indian villages, delivered fresh to your doorstep.
            </p>

            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <a href="#products" className="btn btn-primary btn-lg">Shop Now →</a>
              <a href="#our-story" className="btn btn-outline btn-lg">Our Story</a>
            </div>

            <div style={{ display: 'flex', gap: 24, marginTop: 40, flexWrap: 'wrap' }}>
              {[
                { i: '🌿', t: 'No Chemicals' },
                { i: '👨‍🌾', t: 'Farm Direct' },
                { i: '📦', t: 'Fresh Packed' },
                { i: '🚚', t: 'Free Delivery 500+' },
              ].map((b) => (
                <div key={b.t} style={{ display: 'flex', alignItems: 'center', gap: 6, opacity: 0.75 }}>
                  <span style={{ fontSize: 16 }}>{b.i}</span>
                  <span style={{ fontSize: 12, fontWeight: 500, color: '#4A6B4A' }}>{b.t}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Hero Visual — Logo circle */}
          <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            animation: 'fadeIn 1s ease-out 0.3s both',
          }}>
            <div style={{
              width: 'min(380px, 80vw)', height: 'min(380px, 80vw)',
              borderRadius: '50%', position: 'relative',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'radial-gradient(circle at 40% 40%, rgba(255,255,255,0.5), rgba(212,220,202,0.5))',
              boxShadow: '0 32px 80px rgba(45,90,63,0.15), inset 0 -8px 32px rgba(0,0,0,0.04)',
            }}>
              <img src={logo} alt="Gramaayam" style={{
                width: '72%', height: '72%', borderRadius: '50%',
                objectFit: 'cover',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
              }} />

              {/* Orbiting product icons */}
              {[
                { e: '🥜', a: 0 }, { e: '🌶️', a: 60 }, { e: '🫒', a: 120 },
                { e: '🪷', a: 180 }, { e: '🟫', a: 240 }, { e: '🍯', a: 300 },
              ].map((item, i) => {
                const rad = (item.a * Math.PI) / 180;
                const r = 175;
                return (
                  <div key={i} style={{
                    position: 'absolute',
                    left: `calc(50% + ${Math.cos(rad) * r}px - 22px)`,
                    top: `calc(50% + ${Math.sin(rad) * r}px - 22px)`,
                    width: 44, height: 44, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.92)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 22, boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                    animation: `float ${3 + i * 0.4}s ease-in-out infinite`,
                    animationDelay: `${i * 0.3}s`,
                  }}>{item.e}</div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Scroll hint */}
        <div style={{
          position: 'absolute', bottom: 28, left: '50%', transform: 'translateX(-50%)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
          animation: 'pulse 2s infinite',
        }}>
          <span style={{ fontSize: 10, letterSpacing: 3, color: '#7A8B6F' }}>SCROLL</span>
          <div style={{ width: 1, height: 28, background: 'linear-gradient(to bottom, #7A8B6F, transparent)' }} />
        </div>
      </section>

      {/* ═══════ STATS BANNER ═══════ */}
      <section style={{ background: '#2D3B2D', padding: '36px 24px' }}>
        <div className="container" style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 28, textAlign: 'center',
        }}>
          {[
            { n: '50+', l: 'Village Partners', i: '🏘️' },
            { n: '100%', l: 'Chemical Free', i: '🌿' },
            { n: '10K+', l: 'Happy Customers', i: '😊' },
            { n: '24hr', l: 'Fresh Dispatch', i: '🚚' },
          ].map((s) => (
            <div key={s.l}>
              <span style={{ fontSize: 24 }}>{s.i}</span>
              <div style={{
                fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700,
                color: '#B5C4A8', marginTop: 4,
              }}>{s.n}</div>
              <div style={{ fontSize: 12, color: '#7A8B6F', letterSpacing: 1, marginTop: 4 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ═══════ FEATURED ═══════ */}
      <section style={{ padding: '72px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <span className="section-label">Bestsellers</span>
            <h2 className="section-title">Village Favourites</h2>
            <p className="section-desc" style={{ margin: '12px auto 0' }}>
              Our most loved products — handpicked by thousands of families across India.
            </p>
          </div>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))', gap: 22,
          }}>
            {featured.map((p, i) => <ProductCard key={p._id} product={p} index={i} />)}
          </div>
        </div>
      </section>

      {/* ═══════ PRODUCTS ═══════ */}
      <section id="products" style={{
        padding: '72px 0', background: 'linear-gradient(180deg, #EDE8D8 0%, #FAF8F2 100%)',
      }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <span className="section-label">Our Products</span>
            <h2 className="section-title">Handpicked from Nature</h2>
            <p className="section-desc" style={{ margin: '12px auto 0' }}>
              Every product sourced directly from trusted village farmers and processed using traditional methods.
            </p>
          </div>

          {/* Category Tabs */}
          <div style={{
            display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 36, flexWrap: 'wrap',
          }}>
            {categories.map((c) => (
              <button key={c.id} onClick={() => setActiveCategory(c.id)} style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '9px 18px', borderRadius: 24,
                border: activeCategory === c.id ? '2px solid #2D5A3F' : '2px solid rgba(74,124,89,0.12)',
                background: activeCategory === c.id ? '#2D5A3F' : 'rgba(255,255,255,0.6)',
                color: activeCategory === c.id ? '#F5F0E8' : '#4A6B4A',
                fontSize: 13, fontWeight: 600, transition: 'all 0.3s', letterSpacing: 0.3,
              }}>
                <span>{c.icon}</span> {c.label}
              </button>
            ))}
          </div>

          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))', gap: 22,
          }}>
            {filtered.map((p, i) => <ProductCard key={p._id} product={p} index={i} />)}
          </div>
        </div>
      </section>

      {/* ═══════ OUR STORY ═══════ */}
      <section id="our-story" style={{ padding: '72px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <span className="section-label">Our Story</span>
            <h2 className="section-title">From Our Village to Your Table</h2>
          </div>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 28,
          }}>
            {[
              { i: '👨‍🌾', t: 'Farmer First', d: 'We partner with small-scale village farmers across India, ensuring fair prices and sustainable farming practices that honor traditional knowledge passed down through generations.' },
              { i: '🏺', t: 'Traditional Methods', d: 'From wood-pressed oils to stone-ground spices, every product is made using age-old techniques — kolhu, silbatta, and open-pan methods that preserve nutrition and authentic flavor.' },
              { i: '💚', t: 'Pure & Honest', d: 'Zero chemicals, zero additives, zero shortcuts. What reaches you is exactly what nature intended — pure, wholesome, and full of life. Every batch is tested for quality.' },
            ].map((item) => (
              <div key={item.t} style={{
                background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(8px)',
                padding: 32, borderRadius: 16, border: '1px solid rgba(74,124,89,0.08)',
                transition: 'transform 0.3s', cursor: 'default',
              }}>
                <span style={{ fontSize: 40, display: 'block', marginBottom: 16 }}>{item.i}</span>
                <h3 style={{
                  fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700,
                  color: '#2D3B2D', marginBottom: 12,
                }}>{item.t}</h3>
                <p style={{
                  fontFamily: "'Cormorant Garamond', serif", fontSize: 16,
                  color: '#5A6B5A', lineHeight: 1.7,
                }}>{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ TESTIMONIALS ═══════ */}
      <section style={{ padding: '72px 0', background: '#EDE8D8' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <span className="section-label">Testimonials</span>
            <h2 className="section-title">Loved by Families</h2>
          </div>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 22,
          }}>
            {[
              { n: 'Priya Sharma', c: 'Delhi', t: 'The jaggery powder is a game-changer! My kids love it in their milk. Finally a natural sweetener I can trust completely.', r: 5 },
              { n: 'Ravi Kumar', c: 'Bangalore', t: 'The mustard oil reminds me of my grandmother\'s cooking. Authentic kachi ghani taste — nothing artificial about it.', r: 5 },
              { n: 'Anita Desai', c: 'Mumbai', t: 'Makhana quality is exceptional! Perfectly roasted, fresh, and my go-to evening snack now. The whole family is hooked.', r: 5 },
              { n: 'Dr. Meera Joshi', c: 'Pune', t: 'As a nutritionist, I recommend Gramaayam products to all my clients. The turmeric curcumin content is genuinely superior.', r: 5 },
            ].map((t) => (
              <div key={t.n} style={{
                background: '#FFFEF9', padding: 28, borderRadius: 16,
                border: '1px solid rgba(74,124,89,0.06)',
                boxShadow: '0 2px 8px rgba(45,59,45,0.04)',
              }}>
                <div style={{ fontSize: 16, marginBottom: 12 }}>{'⭐'.repeat(t.r)}</div>
                <p style={{
                  fontFamily: "'Cormorant Garamond', serif", fontSize: 16,
                  color: '#4A5A4A', lineHeight: 1.7, fontStyle: 'italic', marginBottom: 16,
                }}>"{t.t}"</p>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#2D3B2D' }}>{t.n}</div>
                <div style={{ fontSize: 12, color: '#7A8B6F' }}>{t.c}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ CTA / NEWSLETTER ═══════ */}
      <section id="contact" style={{
        background: 'linear-gradient(135deg, #2D3B2D, #1E3F2B)',
        padding: '72px 24px', textAlign: 'center',
      }}>
        <div style={{ maxWidth: 580, margin: '0 auto' }}>
          <span style={{ fontSize: 36 }}>🌿</span>
          <h2 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 700,
            color: '#E8E0CC', marginTop: 12, marginBottom: 12,
          }}>Join the Gramaayam Family</h2>
          <p style={{
            fontFamily: "'Cormorant Garamond', serif", fontSize: 17,
            color: '#A8B89C', lineHeight: 1.7, marginBottom: 28,
          }}>
            Subscribe for seasonal harvests, village stories, and exclusive offers.
          </p>
          <div style={{ display: 'flex', gap: 10, maxWidth: 420, margin: '0 auto' }}>
            <input type="email" placeholder="your@email.com" style={{
              flex: 1, padding: '13px 18px', borderRadius: 28,
              border: '1px solid rgba(181,196,168,0.3)',
              background: 'rgba(255,255,255,0.08)', color: '#E8E0CC',
              fontFamily: "'DM Sans', sans-serif", fontSize: 14, outline: 'none',
            }} />
            <button className="btn" style={{
              background: 'linear-gradient(135deg, #6B9E5A, #4A7C59)',
              color: '#F5F0E8', whiteSpace: 'nowrap', padding: '13px 24px',
            }}>Subscribe</button>
          </div>
        </div>
      </section>
    </>
  );
}
